const carousel = document.querySelector("[data-carousel]");
const prevButton = document.querySelector("[data-carousel-prev]");
const nextButton = document.querySelector("[data-carousel-next]");
const dotsContainer = document.querySelector("[data-carousel-dots]");
const characterCards = Array.from(carousel?.querySelectorAll(".character-card") || []);
let activeCharacter = 0;

const updateCharacterCarousel = () => {
  if (!carousel || !characterCards.length) return;

  const lastIndex = characterCards.length - 1;
  const prevIndex = activeCharacter === 0 ? lastIndex : activeCharacter - 1;
  const nextIndex = activeCharacter === lastIndex ? 0 : activeCharacter + 1;

  characterCards.forEach((card, index) => {
    let state = "hidden";
    if (index === activeCharacter) state = "active";
    if (index === prevIndex) state = "prev";
    if (index === nextIndex) state = "next";

    card.dataset.state = state;
    card.setAttribute("aria-hidden", state === "hidden" ? "true" : "false");
  });

  dotsContainer
    ?.querySelectorAll(".carousel-dot")
    .forEach((dot, index) => {
      dot.classList.toggle("is-active", index === activeCharacter);
      dot.setAttribute("aria-current", index === activeCharacter ? "true" : "false");
    });
};

const moveCharacterCarousel = (direction) => {
  if (!characterCards.length) return;
  activeCharacter =
    (activeCharacter + direction + characterCards.length) % characterCards.length;
  updateCharacterCarousel();
};

if (dotsContainer && characterCards.length) {
  dotsContainer.innerHTML = characterCards
    .map(
      (_, index) =>
        `<button class="carousel-dot" type="button" aria-label="Show character ${index + 1}" data-carousel-dot="${index}"></button>`,
    )
    .join("");

  dotsContainer.querySelectorAll(".carousel-dot").forEach((dot) => {
    dot.addEventListener("click", () => {
      activeCharacter = Number(dot.dataset.carouselDot);
      updateCharacterCarousel();
    });
  });
}

prevButton?.addEventListener("click", () => moveCharacterCarousel(-1));
nextButton?.addEventListener("click", () => moveCharacterCarousel(1));

let touchStartX = 0;
let pointerStartX = 0;
let isPointerDragging = false;

carousel?.addEventListener("touchstart", (event) => {
  touchStartX = event.changedTouches[0].clientX;
});

carousel?.addEventListener("touchend", (event) => {
  const touchEndX = event.changedTouches[0].clientX;
  const delta = touchEndX - touchStartX;

  if (Math.abs(delta) > 40) {
    moveCharacterCarousel(delta > 0 ? -1 : 1);
  }
});

carousel?.addEventListener("pointerdown", (event) => {
  if (event.pointerType === "mouse" && event.button !== 0) return;
  pointerStartX = event.clientX;
  isPointerDragging = true;
  carousel.classList.add("is-dragging");
});

carousel?.addEventListener("pointerup", (event) => {
  if (!isPointerDragging) return;
  const delta = event.clientX - pointerStartX;
  isPointerDragging = false;
  carousel.classList.remove("is-dragging");

  if (Math.abs(delta) > 45) {
    moveCharacterCarousel(delta > 0 ? -1 : 1);
  }
});

carousel?.addEventListener("pointerleave", () => {
  isPointerDragging = false;
  carousel.classList.remove("is-dragging");
});

carousel?.addEventListener("pointercancel", () => {
  isPointerDragging = false;
  carousel.classList.remove("is-dragging");
});

updateCharacterCarousel();

const feedContainer = document.querySelector("[data-social-feed]");
const platformPriority = {
  instagram: 0,
  youtube: 1,
  tiktok: 2,
};

const platformIcons = {
  instagram: `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="4" y="4" width="16" height="16" rx="5"></rect>
      <circle cx="12" cy="12" r="4"></circle>
      <circle cx="17" cy="7" r="1.2"></circle>
    </svg>
  `,
  youtube: `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="3" y="6" width="18" height="12" rx="3"></rect>
      <path d="M10 9.5v5l5-2.5z"></path>
    </svg>
  `,
  tiktok: `<span aria-hidden="true">♪</span>`,
};

const fallbackSocialPosts = [
  {
    platform: "Instagram",
    handle: "@tubbzofficial",
    title: "Follow TUBBZ on Instagram",
    text: "Minions Mystery Egg reveals, collector finds, and launch moments from the TUBBZ team.",
    url: "https://www.instagram.com/tubbzofficial",
    image: "",
    icon: "IG",
    hashtags: ["MinionsMysteryEggs"],
  },
  {
    platform: "YouTube",
    handle: "@tubbz_official",
    title: "See the latest TUBBZ videos",
    text: "Launch videos, character previews, and collector clips from the official TUBBZ channel.",
    url: "https://www.youtube.com/@tubbz_official",
    image: "",
    icon: "YT",
    hashtags: ["MinionsMysteryEggs"],
  },
];

const escapeHtml = (value = "") =>
  String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");

const safeUrl = (value, fallback = "#social") => {
  try {
    const url = new URL(value, window.location.href);
    return ["http:", "https:"].includes(url.protocol) ? url.href : fallback;
  } catch {
    return fallback;
  }
};

const formatPostDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("en", {
    month: "short",
    day: "numeric",
  }).format(date);
};

const normaliseHashtags = (hashtags) => {
  if (!Array.isArray(hashtags)) return [];
  return hashtags
    .map((tag) => String(tag).replace(/^#/, "").trim())
    .filter(Boolean);
};

const normalisePost = (post = {}) => {
  const platform = String(post.platform || "Social").trim();
  const title = String(post.title || `${platform} MinionsMysteryEggs`).trim();
  const text = String(post.text || post.caption || post.description || "").trim();

  return {
    platform,
    title,
    text,
    url: safeUrl(post.url || post.permalink),
    image: post.image || post.thumbnail || post.media_url || "",
    icon: post.icon || platform.slice(0, 2).toUpperCase(),
    handle: post.handle || post.username || "",
    timestamp: post.timestamp || post.publishedAt || post.created_at || "",
    hashtags: normaliseHashtags(post.hashtags),
  };
};

const platformKey = (platform) =>
  String(platform || "social")
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "");

const getPlatformIcon = (platform) =>
  platformIcons[platformKey(platform)] || `<span aria-hidden="true">${escapeHtml(String(platform || "SO").slice(0, 2).toUpperCase())}</span>`;

const getFeedPosts = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.posts)) return data.posts;
  return [];
};

const pickBalancedPosts = (posts, limit) => {
  const sorted = [...posts].sort((a, b) => {
    const aPriority = platformPriority[platformKey(a.platform)] ?? 10;
    const bPriority = platformPriority[platformKey(b.platform)] ?? 10;
    if (aPriority !== bPriority) return aPriority - bPriority;

    const aTime = new Date(a.timestamp || 0).getTime();
    const bTime = new Date(b.timestamp || 0).getTime();
    return bTime - aTime;
  });
  const picked = [];
  const used = new Set();
  const platforms = [...new Set(sorted.map((post) => post.platform))];

  platforms.forEach((platform) => {
    const index = sorted.findIndex((post) => post.platform === platform && !used.has(post.url));
    if (index >= 0 && picked.length < limit) {
      picked.push(sorted[index]);
      used.add(sorted[index].url);
    }
  });

  sorted.forEach((post) => {
    if (picked.length < limit && !used.has(post.url)) {
      picked.push(post);
      used.add(post.url);
    }
  });

  return picked;
};

const prepareSocialPosts = (posts, tag, limit) => {
  const tagText = String(tag || "").replace(/^#/, "").toLowerCase();
  const seen = new Set();
  const normalised = posts
    .map(normalisePost)
    .filter((post) => {
      const key = `${post.platform}:${post.url}:${post.title}`;
      if (seen.has(key)) return false;
      seen.add(key);

      if (!tagText) return true;
      const haystack = `${post.title} ${post.text} ${post.hashtags.join(" ")}`.toLowerCase();
      return haystack.includes(tagText) || post.hashtags.length === 0;
    });

  return pickBalancedPosts(normalised, limit);
};

const renderLoadingSocialFeed = () => {
  if (!feedContainer) return;
  feedContainer.setAttribute("aria-busy", "true");
  feedContainer.innerHTML = Array.from({ length: 3 })
    .map(
      () => `
        <div class="social-card is-loading" aria-hidden="true">
          <div class="social-card-media"></div>
          <span class="social-card-platform"></span>
          <h3></h3>
          <p></p>
        </div>
      `,
    )
    .join("");
};

const renderSocialFeed = (posts) => {
  if (!feedContainer) return;

  feedContainer.removeAttribute("aria-busy");
  feedContainer.innerHTML = posts
    .map((post) => {
      const platform = escapeHtml(post.platform);
      const platformName = platformKey(post.platform);
      const platformIcon = getPlatformIcon(post.platform);
      const title = escapeHtml(post.title);
      const text = escapeHtml(post.text);
      const url = escapeHtml(post.url);
      const icon = escapeHtml(post.icon || platform.slice(0, 2));
      const handle = post.handle ? `<span>${escapeHtml(post.handle)}</span>` : "";
      const dateLabel = formatPostDate(post.timestamp);
      const date = dateLabel
        ? `<time datetime="${escapeHtml(post.timestamp)}">${escapeHtml(dateLabel)}</time>`
        : "";
      const media = post.image
        ? `
          <img class="social-card-backdrop" src="${escapeHtml(post.image)}" alt="" loading="lazy" aria-hidden="true" />
          <img class="social-card-image" src="${escapeHtml(post.image)}" alt="" loading="lazy" />
        `
        : `<span class="social-card-fallback">${icon}</span>`;

      return `
        <a class="social-card" data-platform="${platformName}" href="${url}" target="_blank" rel="noopener">
          <div class="social-card-media">
            ${media}
            <span class="social-card-corner">${platformIcon}</span>
          </div>
          <div class="social-card-meta">
            <span class="social-card-platform">${platformIcon}<span>${platform}</span></span>
            ${handle}
            ${date}
          </div>
          <h3>${title}</h3>
          <p>${text}</p>
        </a>
      `;
    })
    .join("");
};

const fetchFeed = async (url) => {
  if (!url) return null;
  const response = await fetch(url, { cache: "no-store" });
  if (!response.ok) throw new Error("Social feed unavailable");
  return response.json();
};

const loadSocialFeed = async () => {
  if (!feedContainer) return;

  const limit = Number(feedContainer.dataset.feedLimit) || 6;
  const tag = feedContainer.dataset.feedTag || "";
  const endpoint = feedContainer.dataset.feedEndpoint;
  const fallback = feedContainer.dataset.feedFallback || "social-feed.json";
  let posts = [];

  renderLoadingSocialFeed();

  try {
    const liveData = await fetchFeed(endpoint);
    posts = prepareSocialPosts(getFeedPosts(liveData), tag, limit);
  } catch {
    posts = [];
  }

  if (!posts.length) {
    try {
      const fallbackData = await fetchFeed(fallback);
      posts = prepareSocialPosts(getFeedPosts(fallbackData), tag, limit);
    } catch {
      posts = prepareSocialPosts(fallbackSocialPosts, tag, limit);
    }
  }

  renderSocialFeed(posts.length ? posts : prepareSocialPosts(fallbackSocialPosts, tag, limit));
};

loadSocialFeed();
